export class Icon {
  alt: string;
  src: string;
  constructor(data: Icon) {
    this.alt = data.alt;
    this.src = data.src;
  }
}


export const IconsArray: Icon[] = [
  {
    alt: "default",
    src: ""
  },
  {
    alt: "teach",
    src: "app/assets/icons/teach.svg"
  },
  {
    alt: "tableware",
    src: "app/assets/icons/tableware.svg"
  },
  {
    alt: "stronger",
    src: "app/assets/icons/stronger.svg"
  },
  {
    alt: "arrow",
    src: "app/assets/icons/arrow.svg"
  },
  {
    alt: "arrow",
    src: "app/assets/icons/arrow-right.svg"
  },
  {
    alt: "arrow",
    src: "app/assets/icons/arrowGold.svg"
  },
  {
    alt: "arrow",
    src: "app/assets/icons/arrowGoldRight.svg"
  },
  {
    alt: "logo",
    src: "app/assets/icons/logo.svg"
  },
  {
    alt: "logo",
    src: "app/assets/icons/logo-header.svg"
  },
  {
    alt: "teach",
    src: "app/assets/icons/teachGold.svg"
  },
  {
    alt: "stronger",
    src: "app/assets/icons/strongerGold.svg"
  },
  {
    alt: "note",
    src: "app/assets/icons/noteGold.svg"
  },
  {
    alt: "tableware",
    src: "app/assets/icons/tablewareGold.svg"
  },
  {
    alt: "menu",
    src: "app/assets/icons/menu.svg"
  },
  {
    alt: "close",
    src: "app/assets/icons/close.svg"
  },
  {
    alt: "inventory",
    src: "app/assets/icons/inventory.svg"
  },
  {
    alt: "gate",
    src: "app/assets/icons/gate.svg"
  },
  {
    alt: "check",
    src: "app/assets/icons/check.svg"
  },
];
export const Icons = {
  default: IconsArray[0],
  teach: IconsArray[1],
  tableware: IconsArray[2],
  stronger: IconsArray[3],
  arrow: IconsArray[4],
  arrowRight: IconsArray[5],
  arrowGold: IconsArray[6],
  arrowGoldRight: IconsArray[7],
  logo: IconsArray[8],
  logoHeader: IconsArray[9],
  teachGold: IconsArray[10],
  strongerGold: IconsArray[11],
  noteGold: IconsArray[12],
  tablewareGold: IconsArray[13],
  menu: IconsArray[14],
  cross: IconsArray[15],
  inventory: IconsArray[16],
  gate: IconsArray[17],
  check: IconsArray[18],
}
